export class EnableNextPageButton {
    static readonly type = "[Form] Enable next page btn.";
    constructor(public payload: boolean) {}
}
